(() => {
  if (!document.body.classList.contains('template-index')) return;
  if (window.LPLHomepageHybrid) return;
  window.LPLHomepageHybrid = true;
  const body = document.body;
  const measure = () => {
    const headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
    const headerHeight = headers.reduce((height, element) => height + element.getBoundingClientRect().height, 0);
    body.style.setProperty('--lpl-header-h', `${Math.round(headerHeight)}px`);
    const rail = document.createElement('div');
    rail.className = 'page-width';
    rail.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none';
    body.append(rail);
    body.style.setProperty('--lpl-gutter', getComputedStyle(rail).paddingLeft);
    rail.remove();
  };
  measure();
  window.addEventListener('resize', measure, { passive: true });
  const headerObserver = new ResizeObserver(measure);
  document.querySelectorAll('.shopify-section-group-header-group').forEach(element => headerObserver.observe(element));

  function setupHero(hero) {
    if (hero.dataset.lplReady) return;
    hero.dataset.lplReady = 'true';
    window.LPLSwiper.section(hero.dataset.lplHomeHero, (Swiper, scope, lifecycle) => {
      const slider = hero.querySelector('.bs__slider--wrapp');
      const ticks = [...hero.querySelectorAll('.lplh__tick')];
      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        autoHeight: true,
        breakpoints: { 750: { autoHeight: false } },
        rewind: true,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450,
        a11y: { enabled: true },
      });
      const sync = () => {
        ticks.forEach((tick, index) => tick.setAttribute('aria-pressed', String(index === swiper.activeIndex)));
        [...slider.querySelectorAll('.swiper-slide')].forEach((slide, index) => {
          slide.inert = index !== swiper.activeIndex;
        });
      };
      ticks.forEach((tick, index) => lifecycle.listen(tick, 'click', () => swiper.slideTo(index)));
      const next = hero.querySelector('.lplh__next');
      if (next) lifecycle.listen(next, 'click', () => swiper.slideNext());
      swiper.on('slideChange', sync);
      // The mobile panel follows each slide's copy length, including after fonts load.
      const refreshHeight = () => {
        if (!swiper.destroyed && swiper.params.autoHeight) swiper.updateAutoHeight(0);
      };
      lifecycle.listen(window, 'load', refreshHeight);
      if (document.fonts) document.fonts.ready.then(refreshHeight);
      lifecycle.cleanup(() => {
        slider.querySelectorAll('.swiper-slide').forEach(slide => { slide.inert = false; });
        delete hero.dataset.lplReady;
      });
      sync();
    });
  }
  document.querySelectorAll('[data-lpl-home-hero]').forEach(setupHero);
  document.addEventListener('shopify:section:load', event => {
    measure();
    event.target.querySelectorAll('[data-lpl-home-hero]').forEach(setupHero);
  });
})();
